import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AuthService } from '../../../core/services/core/auth/auth.service';
import { MenuService } from '../../../core/services/core/menu.service';
import { PaymentPlanService } from '../../../core/services/http-services/payment-plan.service';

@Component({
  selector: 'mapfre-app-header',
  styleUrls: ['./mapfre-app-header.component.scss'],
  template: `
    <ion-buttons
      class="color-transition"
      [ngClass]="{ 'white': logoColor === 'primary' }"
      slot="start"
      [ngSwitch]="headerButton"
    >
      <ion-back-button
        *ngSwitchCase="'back'"
        style="display: block;"
        text=""
        (click)="onBack()"
      ></ion-back-button>
      <div *ngSwitchCase="'menu'">
        <ion-menu-button mode="md" menu="app-menu"> </ion-menu-button>
      </div>
      <ion-menu-button *ngSwitchDefault mode="md" menu="app-menu">
      </ion-menu-button>
    </ion-buttons>
    <div class="mapfre-logo">
      <img
        *ngFor="let image of images"
        [src]="image.url"
        [@fade]="image.state"
      />
    </div>
    <div></div>
  `,
  animations: [
    trigger('fade', [
    state('show', style({ opacity: '1' })),
    state('hide', style({ opacity: '0' })),
    transition('show => hide', animate('0s')),
    transition('hide => show', animate('0.7s')),
  ])]
})
export class MapfreAppHeaderComponent {
  @Input() headerButton: 'back' | 'menu';
  @Input() defaultHref: string;
  @Input() set logoColor(value: any) {
    this._logoColor = value;
    this.setImgState();
  }
  get logoColor() {
    return this._logoColor;
  }

  private _logoColor = 'base';

  images = [
    {
      id: 'base',
      url: 'assets/images/mapfre-logo.svg',
      state: 'show',
    },
    {
      id: 'primary',
      url: 'assets/images/mapfre-logo-white.svg',
      state: 'hide',
    }
  ];

  constructor(
    public menu: MenuService,
    public auth: AuthService,
    public paymentPlanService: PaymentPlanService,
    private nav: NavController
  ) {}

  onBack() {
    this.defaultHref
      ? this.nav.navigateRoot(this.defaultHref, { animationDirection: 'back' })
      : this.nav.pop();
  }

  setImgState() {
    this.images.forEach(
      img => img.state = img.id === this._logoColor ? 'show' : 'hide'
    );
  }
}
